import cs from 'classnames';

import styles from './Report.module.scss';

export const ReportSubtitle = (props) => (
  <div className={cs(styles.row, styles.subtitle)} {...props} />
);
